(function(){
  const rose='#BB6765';
  const green='#324F4D';
  const white='#FFFFFF';
  const storageKey='vikarCartItems';
  const style=document.createElement('style');
  style.textContent=`
    .cart-nav-icon,.cart-launcher{position:relative;width:31px;height:31px;padding:0!important;display:flex!important;align-items:center!important;justify-content:center!important;border:0!important;background:transparent!important;color:${rose}!important;border-radius:50%!important;text-indent:0!important;text-decoration:none!important;white-space:nowrap!important;transition:color .25s ease,transform .25s ease,background .25s ease!important}
    .cart-icon-group{display:flex!important;align-items:center!important;justify-content:flex-end!important;gap:.92rem!important;margin-left:auto!important;flex:0 0 auto!important}
    .cart-nav-icon:hover,.cart-launcher:hover{color:${green}!important;background:rgba(244,201,199,.18)!important;transform:translateY(-1px)}
    .cart-launcher.cart-icon-only{width:31px;height:31px}
    .cart-nav-icon svg,.cart-launcher.cart-icon-only svg{width:22px;height:22px}
    .cart-launcher.cart-icon-only span:not(.cart-count){display:none!important}
    .cart-count{position:absolute;right:-7px;top:-7px;min-width:22px;height:22px;border-radius:999px;background:${rose};color:${white};display:none;align-items:center;justify-content:center;font-size:.68rem;letter-spacing:0;font-weight:500;box-shadow:0 6px 16px rgba(187,103,101,.24)}
    .cart-launcher.has-items .cart-count{display:flex}
    .cart-launcher.cart-pop{animation:vikarCartPop .45s cubic-bezier(.2,.8,.25,1)}
    @keyframes vikarCartPop{0%{transform:scale(1)}38%{transform:scale(.9)}72%{transform:scale(1.09)}100%{transform:scale(1)}}
    .cart-fly{position:fixed;width:14px;height:14px;border-radius:50%;background:${rose};z-index:1005;pointer-events:none;box-shadow:0 0 0 8px rgba(187,103,101,.14);animation:vikarCartFly .72s ease forwards}
    @keyframes vikarCartFly{to{transform:translate(var(--cart-x),var(--cart-y)) scale(.35);opacity:0}}
    .cart-shade{position:fixed;inset:0;background:rgba(50,79,77,.36);z-index:900;opacity:0;pointer-events:none;transition:opacity .34s ease;backdrop-filter:blur(2px)}
    .cart-shade.open{opacity:1;pointer-events:auto}
    .cart-drawer{position:fixed;top:0;right:0;width:min(94vw,540px);height:100dvh;background:linear-gradient(180deg,#fff 0%,#fff 48%,#F9F9F9 100%);z-index:901;transform:translateX(104%);transition:transform .48s cubic-bezier(.2,.72,.18,1);box-shadow:-24px 0 70px rgba(50,79,77,.14);display:block;border-left:1px solid rgba(244,201,199,.72);overflow:hidden}
    .cart-drawer::before{content:'';position:absolute;left:0;right:0;top:0;height:5px;background:linear-gradient(90deg,${rose},#F4C9C7,${green});opacity:.85}
    .cart-drawer::after{content:'';position:absolute;right:-120px;top:90px;width:260px;height:260px;border-radius:50%;background:radial-gradient(circle,rgba(244,201,199,.28),transparent 68%);pointer-events:none}
    .cart-drawer.open{transform:translateX(0)}
    .cart-close{position:absolute;top:28px;right:28px;width:38px;height:38px;border-radius:50%;border:0;background:transparent;color:${rose};display:grid;place-items:center;cursor:pointer;transition:transform .25s ease,color .25s ease,background .25s ease;z-index:2}
    .cart-close:hover{background:rgba(244,201,199,.22);color:${green};transform:rotate(90deg)}
    .cart-close svg{width:24px;height:24px}
    .cart-content{height:100%;display:flex;flex-direction:column;align-items:center;justify-content:center;text-align:center;padding:6rem 2.2rem 3rem;color:${rose};position:relative;z-index:1}
    .cart-empty-icon{width:86px;height:86px;border-radius:50%;display:grid;place-items:center;margin-bottom:1.35rem;background:linear-gradient(180deg,rgba(244,201,199,.32),rgba(255,255,255,.72));border:1px solid rgba(187,103,101,.24);color:${rose};box-shadow:0 20px 54px rgba(50,79,77,.08)}
    .cart-empty-icon svg{width:38px;height:38px}
    .cart-empty-title{font-family:'Cormorant Garamond',serif;font-weight:400;font-size:clamp(2rem,4.4vw,2.75rem);line-height:1.05;margin-bottom:.65rem;color:${green}}
    .cart-empty-copy{font-size:clamp(.92rem,2vw,1.05rem);line-height:1.65;color:${rose};margin-bottom:2rem;max-width:310px}
    .cart-empty-copy a{color:${green};text-decoration:underline;text-underline-offset:3px}
    .cart-continue,.cart-checkout{border:0;background:${rose};color:${white};width:100%;max-width:320px;padding:1rem 1.4rem;font-family:'Jost',sans-serif;font-size:.82rem;letter-spacing:.16em;text-transform:uppercase;cursor:pointer;transition:background .25s ease,transform .25s ease,box-shadow .25s ease;border-radius:4px;box-shadow:0 14px 34px rgba(187,103,101,.2)}
    .cart-continue:hover,.cart-checkout:hover{background:${green};transform:translateY(-2px);box-shadow:0 18px 40px rgba(50,79,77,.18)}
    .cart-filled{height:100dvh;width:100%;display:flex;flex-direction:column;text-align:left;color:${rose};padding:2rem 1.8rem 1.7rem;background:transparent;position:relative;z-index:1}
    .cart-kicker{font-size:.58rem;letter-spacing:.28em;text-transform:uppercase;color:rgba(187,103,101,.72);margin:0 0 .55rem}
    .cart-title-row{display:flex;align-items:center;gap:.72rem;margin-bottom:1.2rem;padding-right:3.5rem}
    .cart-title{font-family:'Cormorant Garamond',serif;font-size:2.75rem;font-weight:400;color:${green};margin:0;line-height:.95}
    .cart-title-count{width:30px;height:30px;border-radius:50%;background:rgba(244,201,199,.44);display:grid;place-items:center;color:${rose};font-size:.88rem}
    .cart-shipping-note{display:flex;align-items:center;gap:.6rem;margin-bottom:1.35rem;padding:.82rem .95rem;border:1px solid rgba(244,201,199,.9);background:rgba(255,255,255,.76);border-radius:6px;color:${green};font-size:.78rem;line-height:1.45;box-shadow:0 14px 34px rgba(50,79,77,.045)}
    .cart-shipping-note svg{width:18px;height:18px;color:${rose};flex:0 0 auto}
    .cart-list{display:grid;gap:.95rem;margin-bottom:1.2rem;overflow:auto;padding-right:.25rem}
    .cart-item{display:grid;grid-template-columns:82px minmax(0,1fr);gap:1rem;align-items:start;background:rgba(255,255,255,.86);padding:.9rem;border:1px solid rgba(244,201,199,.78);border-radius:8px;box-shadow:0 18px 44px rgba(50,79,77,.055);animation:vikarCartItem .42s ease both}
    @keyframes vikarCartItem{from{opacity:0;transform:translateX(22px)}to{opacity:1;transform:translateX(0)}}
    .cart-item img{width:82px;height:100px;object-fit:contain;border-radius:7px;background:linear-gradient(180deg,#fff,#F9F9F9);border:1px solid rgba(244,201,199,.52)}
    .cart-item-main{min-width:0}
    .cart-item-top{display:grid;grid-template-columns:minmax(0,1fr) auto;gap:1rem;margin-bottom:.55rem}
    .cart-item h4{font-family:'Cormorant Garamond',serif;font-size:1.35rem;line-height:1.1;font-weight:400;color:${green};margin:0}
    .cart-line-price{font-size:.95rem;color:${rose};white-space:nowrap}
    .cart-item-desc{font-size:.78rem;line-height:1.55;color:rgba(50,79,77,.74);margin:0 0 .52rem}
    .cart-unit-price{font-size:.86rem;color:${rose};margin:0 0 .85rem;letter-spacing:.04em}
    .cart-item-actions{display:flex;align-items:center;gap:.75rem;flex-wrap:wrap}
    .cart-qty{height:40px;min-width:118px;display:grid;grid-template-columns:36px 1fr 36px;border:1px solid rgba(50,79,77,.16);background:#fff;border-radius:4px;overflow:hidden}
    .cart-qty button{border:0;background:transparent;color:${green};font-size:1.25rem;cursor:pointer;padding:0;line-height:1;transition:background .2s ease,color .2s ease}
    .cart-qty button:hover{background:rgba(244,201,199,.28);color:${rose}}
    .cart-qty span{display:grid;place-items:center;color:${green};font-size:1rem}
    .cart-remove{border:0;background:rgba(244,201,199,.22);border-radius:50%;color:${rose};width:34px;height:34px;display:grid;place-items:center;cursor:pointer;padding:0;transition:background .2s ease,color .2s ease}
    .cart-remove:hover{background:${green};color:#fff}
    .cart-remove svg{width:19px;height:19px}
    .cart-bottom{margin-top:auto;border-top:1px solid rgba(187,103,101,.72);padding-top:1rem;background:linear-gradient(180deg,rgba(255,255,255,.82),#fff);box-shadow:0 -22px 42px rgba(255,255,255,.86)}
    .cart-discount{display:flex;justify-content:space-between;align-items:center;border-bottom:1px solid rgba(187,103,101,.55);padding:0 0 1rem;color:${rose};font-size:.94rem}
    .cart-discount button{border:0;background:transparent;color:${rose};font-size:1.6rem;line-height:1;cursor:pointer}
    .cart-total{display:flex;justify-content:space-between;align-items:center;padding-top:1.35rem;margin-bottom:1rem;color:${green};font-size:1.05rem}
    .cart-total strong{font-weight:400}
    .cart-note{font-size:.82rem;line-height:1.55;color:rgba(187,103,101,.72);margin-bottom:1.35rem}
    .cart-checkout{max-width:none}
    .search-panel{position:fixed;inset:0;z-index:920;background:rgba(255,255,255,.94);backdrop-filter:blur(20px);opacity:0;pointer-events:none;transition:opacity .28s ease;display:flex;align-items:flex-start;justify-content:center;padding:8rem 5vw 3rem}
    .search-panel.open{opacity:1;pointer-events:auto}
    .search-box{width:min(760px,100%);background:linear-gradient(180deg,#fff,#F9F9F9);border:1px solid rgba(244,201,199,.9);border-radius:8px;box-shadow:0 28px 80px rgba(50,79,77,.12);padding:1.4rem;position:relative}
    .search-close{position:absolute;right:1rem;top:1rem;width:34px;height:34px;border:0;border-radius:50%;background:rgba(244,201,199,.24);color:${rose};cursor:pointer;display:grid;place-items:center}
    .search-title{font-family:'Cormorant Garamond',serif;font-size:2.1rem;color:${green};font-weight:400;margin:0 2.8rem 1rem 0}
    .search-field{width:100%;height:54px;border:1px solid rgba(187,103,101,.32);border-radius:5px;background:#fff;color:${green};font-family:'Jost',sans-serif;font-size:1rem;padding:0 1rem;outline:none}
    .search-field:focus{border-color:${green};box-shadow:0 0 0 3px rgba(50,79,77,.08)}
    .search-results{display:grid;gap:.7rem;margin-top:1rem;max-height:min(52vh,440px);overflow:auto;padding-right:.2rem}
    .search-result{display:grid;grid-template-columns:64px minmax(0,1fr) auto;gap:.85rem;align-items:center;text-decoration:none;background:#fff;border:1px solid rgba(244,201,199,.68);border-radius:7px;padding:.65rem;transition:transform .2s ease,border-color .2s ease,box-shadow .2s ease}
    .search-result:hover{transform:translateY(-2px);border-color:${green};box-shadow:0 14px 30px rgba(50,79,77,.08)}
    .search-result img{width:64px;height:76px;object-fit:contain;background:#F9F9F9;border-radius:5px}
    .search-result h3{font-family:'Cormorant Garamond',serif;font-size:1.25rem;font-weight:400;color:${green};margin:0 0 .18rem}
    .search-result p{font-size:.76rem;line-height:1.45;color:rgba(50,79,77,.76);margin:0}
    .search-result span{font-size:.76rem;color:${rose};white-space:nowrap}
    .search-empty{padding:1.2rem;border:1px solid rgba(244,201,199,.78);border-radius:7px;color:${rose};text-align:center}
    body.cart-locked{overflow:hidden}
    @media(max-width:720px){
      .cart-drawer{width:min(94vw,430px)}
      .cart-close{width:34px;height:34px;top:20px;right:18px}
      .cart-close svg{width:22px;height:22px}
      .cart-content{padding:5rem 1.4rem 2.5rem}
      .cart-empty-title{font-size:1.75rem}
      .cart-empty-copy{font-size:.92rem}
      .cart-nav-icon,.cart-launcher.cart-icon-only{width:28px;height:28px}
      .cart-nav-icon svg,.cart-launcher.cart-icon-only svg{width:19px;height:19px}
      .cart-icon-group{gap:.68rem!important;margin-left:0!important;justify-self:end!important}
      .cart-count{min-width:19px;height:19px;font-size:.6rem;right:-7px;top:-7px}
      .cart-filled{padding:1.45rem 1.2rem 1.45rem}
      .cart-title{font-size:1.65rem}
      .cart-title-count{width:28px;height:28px;font-size:.82rem}
      .cart-item{grid-template-columns:58px minmax(0,1fr)}
      .cart-line-price{display:none}
      .cart-item img{width:58px;height:74px}
      .cart-item h4{font-size:1rem}
      .cart-item-desc{font-size:.82rem}
      .cart-qty{height:42px;min-width:118px;grid-template-columns:36px 1fr 36px}
      .search-panel{padding:5.8rem 1rem 2rem}
      .search-box{padding:1rem}
      .search-title{font-size:1.65rem}
      .search-result{grid-template-columns:52px minmax(0,1fr)}
      .search-result img{width:52px;height:64px}
      .search-result span{grid-column:2}
    }
    @media(hover:none),(pointer:coarse){
      .cart-nav-icon:hover,.cart-launcher:hover,.cart-continue:hover,.cart-checkout:hover,.search-result:hover,.cart-remove:hover,.cart-qty button:hover{transform:none!important}
    }
    @media(prefers-reduced-motion:no-preference){
      .cart-nav-icon,.cart-launcher,.cart-shade,.cart-drawer,.cart-close,.cart-continue,.cart-checkout,.cart-item,.cart-qty button,.cart-remove,.search-panel,.search-result{
        transition-timing-function:cubic-bezier(.19,1,.22,1)!important;
      }
    }
    @media(prefers-reduced-motion:reduce){
      .cart-launcher.cart-pop,.cart-fly,.cart-item{animation:none!important}
      .cart-nav-icon,.cart-launcher,.cart-shade,.cart-drawer,.cart-close,.cart-continue,.cart-checkout,.cart-item,.cart-qty button,.cart-remove,.search-panel,.search-result{transition:none!important}
    }
  `;
  document.head.appendChild(style);

  const drawer=document.createElement('div');
  drawer.innerHTML=`
    <div class="cart-shade" data-cart-close></div>
    <aside class="cart-drawer" aria-hidden="true" aria-label="Shopping cart">
      <button class="cart-close" type="button" aria-label="Close cart" data-cart-close>
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.4"><path d="M6 6l12 12M18 6L6 18"/></svg>
      </button>
      <div class="cart-content" data-cart-content></div>
    </aside>
    <aside class="search-panel" aria-hidden="true" aria-label="Search products">
      <div class="search-box">
        <button class="search-close" type="button" aria-label="Close search" data-search-close>
          <svg viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="currentColor" stroke-width="1.5"><path d="M6 6l12 12M18 6L6 18"/></svg>
        </button>
        <h2 class="search-title">Search Vikar Beauty</h2>
        <input class="search-field" type="search" placeholder="Search lipsticks, blushes, bundles..." aria-label="Search products" data-search-input>
        <div class="search-results" data-search-results></div>
      </div>
    </aside>
  `;
  document.body.appendChild(drawer);

  const shade=document.querySelector('.cart-shade');
  const panel=document.querySelector('.cart-drawer');
  const content=document.querySelector('[data-cart-content]');
  const searchPanel=document.querySelector('.search-panel');
  const searchInput=document.querySelector('[data-search-input]');
  const searchResults=document.querySelector('[data-search-results]');
  const searchSvg='<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.55"><circle cx="10.5" cy="10.5" r="6.5"/><path d="M16 16l5 5"/></svg>';
  const accountSvg='<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.55"><circle cx="12" cy="7" r="3"/><path d="M5 21c.8-4 3.2-6 7-6s6.2 2 7 6"/></svg>';
  const bagSvg='<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.55"><path d="M6.5 8h11l-.8 11H7.3L6.5 8z"/><path d="M9.2 8V6.5a2.8 2.8 0 0 1 5.6 0V8"/></svg><span>Cart</span>';
  const searchProducts=[
    {name:'Velvet Era Lipsticks',type:'6 shades',price:'₹999',url:'product-graceful.html',image:'assets/products/graceful-product-user.png'},
    {name:'Glow Era Blushes',type:'5 shades',price:'₹799',url:'product-glowup.html',image:'assets/catalog/glowup-2.png'},
    {name:'Lipstick & Blush Combo',type:'Choose your shades',price:'₹1,599',url:'product-era-bundle.html',image:'assets/products/bundle-combo-cap.png'},
    {name:'Velvet Era Lipsticks - Pack of 2',type:'Choose 2 shades',price:'₹1,799',url:'product-lipstick-pack-2.html',image:'assets/products/velvet-lipstick-pack-2.png'},
    {name:'Glow Era Blushes - Pack of 2',type:'Choose 2 shades',price:'₹1,399',url:'product-blush-pack-2.html',image:'assets/products/glow-era-blush-pack-2-user.png'}
  ];
  let cart=[];
  function asset(src){return window.vikarResolveAsset?window.vikarResolveAsset(src):src}
  const fallbackProductImage=asset('assets/product-lipstick.svg');
  const shopifyRoutes=(window.vikarShopify&&window.vikarShopify.routes)||{};
  const useShopifyCart=Boolean(shopifyRoutes.cartJsonUrl&&shopifyRoutes.cartAddUrl&&shopifyRoutes.cartChangeUrl);
  let cartSyncVersion=0;
  let cartBusy=false;
  let searchToken=0;

  if(!useShopifyCart){try{cart=JSON.parse(localStorage.getItem(storageKey)||'[]')}catch(error){cart=[]}}

  function moneyToNumber(price){
    const value=(price||'').replace(/[^\d]/g,'');
    return Number(value||0);
  }
  function formatCartMoney(cents){return `₹${Math.round(Number(cents||0)/100).toLocaleString('en-IN')}`}
  function normalizeShopifyImage(src){if(!src) return fallbackProductImage; return src.startsWith('//')?`https:${src}`:src}
  async function syncCartFromShopify(){
    if(!useShopifyCart) return;
    const version=++cartSyncVersion;
    try{
      const response=await fetch(shopifyRoutes.cartJsonUrl,{headers:{'Accept':'application/json'}});
      if(!response.ok) throw new Error('Unable to load cart');
      const data=await response.json();
      if(version!==cartSyncVersion) return;
      cart=(data.items||[]).map(item=>({
        key:item.key,variantId:item.variant_id,name:item.product_title||item.title,
        price:formatCartMoney(item.final_price||item.price),image:normalizeShopifyImage(item.image),
        desc:[item.variant_title&&item.variant_title!=='Default Title'?item.variant_title:'',...Object.values(item.properties||{}).filter(Boolean)].filter(Boolean).join(' · ')||'Clean colour, soft comfort, and Vikar Beauty’s signature finish.',
        qty:item.quantity
      }));
      save();updateBadges();
    }catch(error){}
  }
  async function addShopifyItem(item){
    if(!useShopifyCart||!item?.variantId) return false;
    try{
      cartSyncVersion+=1;
      const line={id:Number(item.variantId),quantity:Math.max(1,Number(item.qty||1))};
      if(item.properties&&Object.keys(item.properties).length) line.properties=item.properties;
      const response=await fetch(shopifyRoutes.cartAddUrl,{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({items:[line]})});
      if(!response.ok) throw new Error('Unable to add item');
      await syncCartFromShopify();
      return true;
    }catch(error){return false}
  }
  async function changeShopifyCart(item,quantity){
    if(!useShopifyCart||!item?.key) return false;
    try{
      cartSyncVersion+=1;
      const response=await fetch(shopifyRoutes.cartChangeUrl,{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({id:item.key,quantity})});
      if(!response.ok) throw new Error('Unable to update cart');
      await syncCartFromShopify();return true;
    }catch(error){return false}
  }
  function save(){if(!useShopifyCart) localStorage.setItem(storageKey,JSON.stringify(cart))}
  function count(){return cart.reduce((sum,item)=>sum+item.qty,0)}
  function updateBadges(){
    document.querySelectorAll('.cart-launcher').forEach(btn=>{
      btn.classList.toggle('has-items',count()>0);
      const badge=btn.querySelector('.cart-count');
      if(badge) badge.textContent=count();
    });
  }
  function render(){
    if(!cart.length){
      content.className='cart-content';
      content.innerHTML=`
        <div class="cart-empty-icon">
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.45"><path d="M6.5 8h11l-.8 11H7.3L6.5 8z"/><path d="M9.2 8V6.5a2.8 2.8 0 0 1 5.6 0V8"/></svg>
        </div>
        <h2 class="cart-empty-title">Your cart is empty</h2>
        <p class="cart-empty-copy">Have an account? <a href="${shopifyRoutes.accountLoginUrl||'#'}">Log in</a> to check out faster.</p>
        <button type="button" class="cart-continue" data-cart-close>Continue Shopping</button>
      `;
      return;
    }
    const total=cart.reduce((sum,item)=>sum+(moneyToNumber(item.price)*item.qty),0);
    content.className='cart-filled';
    content.innerHTML=`
      <p class="cart-kicker">Vikar Beauty</p>
      <div class="cart-title-row"><h2 class="cart-title">Cart</h2><span class="cart-title-count">${count()}</span></div>
      <div class="cart-shipping-note">
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.45"><path d="M3 7h11v10H3z"/><path d="M14 10h4l3 3v4h-7z"/><circle cx="7" cy="18" r="2"/><circle cx="18" cy="18" r="2"/></svg>
        <span>${total>=799 ? 'Your order qualifies for complimentary shipping.' : `Add ₹${(799-total).toLocaleString('en-IN')} more for complimentary shipping.`}</span>
      </div>
      <div class="cart-list">
        ${cart.map((item,index)=>`
          <div class="cart-item">
            <img src="${asset(item.image)}" alt="${item.name}">
            <div class="cart-item-main">
              <div class="cart-item-top">
                <h4>${item.name}</h4>
                <span class="cart-line-price">₹${(moneyToNumber(item.price)*item.qty).toLocaleString('en-IN')}</span>
              </div>
              <p class="cart-item-desc">${item.desc||'Clean colour, soft comfort, and Vikar Beauty’s signature finish.'}</p>
              <p class="cart-unit-price">${item.price}</p>
              <div class="cart-item-actions">
                <div class="cart-qty" aria-label="Quantity controls">
                  <button type="button" aria-label="Decrease quantity" data-cart-qty="${index}" data-delta="-1">−</button>
                  <span>${item.qty}</span>
                  <button type="button" aria-label="Increase quantity" data-cart-qty="${index}" data-delta="1">+</button>
                </div>
                <button class="cart-remove" type="button" aria-label="Remove ${item.name}" data-cart-remove="${index}">
                  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.45"><path d="M3 6h18"/><path d="M8 6V4h8v2"/><path d="M19 6l-1 15H6L5 6"/><path d="M10 11v6M14 11v6"/></svg>
                </button>
              </div>
            </div>
          </div>
        `).join('')}
      </div>
      <div class="cart-bottom">
        <div class="cart-discount"><span>Discount</span><button type="button" aria-label="Add discount">+</button></div>
        <div class="cart-total"><span>Estimated total</span><strong>₹${total.toLocaleString('en-IN')}</strong></div>
        <p class="cart-note">Duties and taxes included. Shipping is calculated at checkout.</p>
        <button type="button" class="cart-checkout">Check Out</button>
      </div>
    `;
  }
  function openCart(){
    render();
    syncCartFromShopify().then(render);
    shade.classList.add('open');
    panel.classList.add('open');
    panel.setAttribute('aria-hidden','false');
    document.body.classList.add('cart-locked');
  }
  function closeCart(){
    shade.classList.remove('open');
    panel.classList.remove('open');
    panel.setAttribute('aria-hidden','true');
    document.body.classList.remove('cart-locked');
  }
  function renderSearch(query=''){
    
    const value=query.trim().toLowerCase();
    const renderMatches=matches=>{
      searchResults.innerHTML=matches.length?matches.map(item=>`
        <a class="search-result" href="${window.vikarProductUrlFor?window.vikarProductUrlFor(item.url):item.url}">
          <img src="${asset(item.image)}" alt="${item.name}" onerror="this.onerror=null;this.src='${fallbackProductImage}'">
          <div><h3>${item.name}</h3><p>${item.type}</p></div><span>${item.price}</span>
        </a>`).join(''):'<div class="search-empty">No products found. Try lipstick, blush, or bundle.</div>';
    };
    renderMatches(searchProducts.filter(item=>`${item.name} ${item.type}`.toLowerCase().includes(value)).slice(0,8));
    if(value.length>1&&shopifyRoutes.predictiveSearchUrl){
      const token=++searchToken;
      fetch(`${shopifyRoutes.predictiveSearchUrl}.json?q=${encodeURIComponent(query)}&resources[type]=product&resources[limit]=8`,{headers:{'Accept':'application/json'}})
        .then(response=>response.json()).then(data=>{
          if(token!==searchToken) return;
          const matches=data?.resources?.results?.products||[];
          if(matches.length) renderMatches(matches.map(item=>({name:item.title||'Vikar Beauty Product',type:item.type||item.vendor||'Vikar Beauty',price:item.price||'',url:item.url||shopifyRoutes.allProductsUrl,image:normalizeShopifyImage(item.featured_image?.url||item.featured_image||item.image)})));
        }).catch(()=>{});
    }
  }
  function openSearch(){
    renderSearch(searchInput.value);
    searchPanel.classList.add('open');
    searchPanel.setAttribute('aria-hidden','false');
    document.body.classList.add('cart-locked');
    window.setTimeout(()=>searchInput.focus(),80);
  }
  function closeSearch(){
    searchPanel.classList.remove('open');
    searchPanel.setAttribute('aria-hidden','true');
    document.body.classList.remove('cart-locked');
  }
  function addFlyAnimation(trigger){
    if(!trigger) return;
    trigger.classList.remove('cart-pop');
    void trigger.offsetWidth;
    trigger.classList.add('cart-pop');
    const target=document.querySelector('.cart-launcher');
    if(!target) return;
    const a=trigger.getBoundingClientRect();
    const b=target.getBoundingClientRect();
    const dot=document.createElement('span');
    dot.className='cart-fly';
    dot.style.left=`${a.left+a.width/2}px`;
    dot.style.top=`${a.top+a.height/2}px`;
    dot.style.setProperty('--cart-x',`${b.left+b.width/2-a.left-a.width/2}px`);
    dot.style.setProperty('--cart-y',`${b.top+b.height/2-a.top-a.height/2}px`);
    document.body.appendChild(dot);
    dot.addEventListener('animationend',()=>dot.remove(),{once:true});
  }
  function productFromTrigger(trigger){
    if(trigger.dataset.productName){
      return {
        name:trigger.dataset.productName,
        price:trigger.dataset.productPrice||'₹999',
        image:trigger.dataset.productImage||document.querySelector('[data-main-image]')?.src||'https://vikarbeauty.com/cdn/shop/files/graceful.jpg?v=1772450961&width=500',
        desc:(trigger.dataset.productDesc||'Clean colour, soft comfort, and Vikar Beauty’s signature finish.').slice(0,86),
        qty:Math.max(1,Number(trigger.dataset.productQty||1)),
        variantId:trigger.dataset.variantId,
        properties:(()=>{try{return JSON.parse(trigger.dataset.productProperties||'{}')}catch(error){return {}}})()
      };
    }
    const product=trigger.closest('.product-card,.pcard,.bundle,.spot-body')||trigger;
    let name=product.querySelector('.pname,.product-info h3,.b-title,[data-lipstick-content="title"],[data-blush-content="title"]')?.textContent?.replace(/\s+/g,' ').trim()||trigger.textContent.trim()||'Vikar Beauty Product';
    name=name.replace(/Creamy on Application\.?\s*Velvety Matte on Wear\.?/i,'Velvet Era Lipsticks')
      .replace(/A Soft Flush That\s*Feels Like Skin\.?/i,'Glow Era Blushes')
      .replace(/Beautyin EveryEra\.?/i,'Vikar Beauty Product')
      .slice(0,70);
    const price=product.querySelector('.pprice,.price,.b-price-big')?.textContent?.match(/₹[\d,]+/)?.[0]||trigger.textContent.match(/₹[\d,]+/)?.[0]||'₹999';
    const image=product.querySelector('img')?.src||document.querySelector('.hero-product')?.src||'https://vikarbeauty.com/cdn/shop/files/graceful.jpg?v=1772450961&width=500';
    const desc=product.querySelector('.product-info p:not(.price),.spot-desc,.b-sub')?.textContent?.replace(/\s+/g,' ').trim().slice(0,86)||'Clean colour, soft comfort, and Vikar Beauty’s signature finish.';
    return {name,price,image,desc,qty:1};
  }
  function addItem(item){
    const existing=cart.find(entry=>entry.name===item.name&&entry.price===item.price);
    if(existing) existing.qty+=item.qty||1;
    else cart.push(item);
    save();
    updateBadges();
  }
  function setupLaunchers(){
    document.querySelectorAll('.nav-cart,.shop-link').forEach(btn=>{
      if(!btn.closest('.cart-icon-group')){
        const group=document.createElement('div');
        group.className='cart-icon-group';
        btn.insertAdjacentElement('beforebegin',group);
        group.insertAdjacentHTML('beforeend',`
          <a href="#" class="cart-nav-icon cart-search-icon" aria-label="Search">
            ${searchSvg}
          </a>
          <a href="#" class="cart-nav-icon cart-account-icon" aria-label="Account">
            ${accountSvg}
          </a>
        `);
        group.appendChild(btn);
      }
      btn.classList.add('cart-launcher');
      if(btn.classList.contains('shop-link') || btn.classList.contains('nav-cart')){
        btn.classList.add('cart-icon-only');
        btn.innerHTML=bagSvg;
      }
      if(!btn.querySelector('.cart-count')) btn.insertAdjacentHTML('beforeend','<span class="cart-count">0</span>');
      btn.setAttribute('aria-label','Open cart');
    });
  }
  function setupAddButtons(){
    document.querySelectorAll('[data-add]').forEach(btn=>{
      if(btn.closest('form')) return;
      btn.classList.add('cart-add-trigger');
    });
  }
  setupLaunchers();
  setupAddButtons();
  updateBadges();
  syncCartFromShopify();

  document.addEventListener('click',async event=>{
    const close=event.target.closest('[data-cart-close]');
    if(close){event.preventDefault();closeCart();return}
    const searchClose=event.target.closest('[data-search-close]');
    if(searchClose){event.preventDefault();closeSearch();return}
    const remove=event.target.closest('[data-cart-remove]');
    if(remove){
      event.preventDefault();
      const index=Number(remove.dataset.cartRemove);
      const item=cart[index];
      if(!item||cartBusy) return;
      if(useShopifyCart){
        cartBusy=true;
        const ok=await changeShopifyCart(item,0);
        cartBusy=false;
        if(!ok) await syncCartFromShopify();
      }else{cart.splice(index,1);save();updateBadges()}
      render();return;
    }
    const qty=event.target.closest('[data-cart-qty]');
    if(qty){
      event.preventDefault();
      const index=Number(qty.dataset.cartQty);
      const delta=Number(qty.dataset.delta);
      if(cart[index]){
        const item=cart[index];
        const nextQty=Math.max(0,item.qty+delta);
        if(cartBusy) return;
        if(useShopifyCart){
          cartBusy=true;
          const ok=await changeShopifyCart(item,nextQty);
          cartBusy=false;
          if(!ok) await syncCartFromShopify();
        }else{
          item.qty=nextQty;
          if(nextQty<=0) cart.splice(index,1);
          save();updateBadges();
        }
        render();
      }
      return;
    }
    const launcher=event.target.closest('.cart-launcher');
    if(launcher){event.preventDefault();addFlyAnimation(launcher);openCart();return}
    const searchIcon=event.target.closest('.cart-search-icon');
    if(searchIcon){
      event.preventDefault();
      searchIcon.classList.remove('cart-pop');
      void searchIcon.offsetWidth;
      searchIcon.classList.add('cart-pop');
      openSearch();
      return;
    }
    const headerIcon=event.target.closest('.cart-account-icon');
    if(headerIcon){
      event.preventDefault();headerIcon.classList.remove('cart-pop');void headerIcon.offsetWidth;headerIcon.classList.add('cart-pop');
      if(shopifyRoutes.accountUrl) window.location.href=shopifyRoutes.accountUrl;
      return;
    }
    const checkout=event.target.closest('.cart-checkout');
    if(checkout&&(shopifyRoutes.cartUrl||shopifyRoutes.checkoutUrl)){
      event.preventDefault();
      window.location.href=shopifyRoutes.cartUrl||shopifyRoutes.checkoutUrl;
      return;
    }
    const add=event.target.closest('.cart-add-trigger');
    if(add){
      event.preventDefault();
      if(add.disabled||add.getAttribute('aria-disabled')==='true') return;
      addFlyAnimation(add);
      const item=productFromTrigger(add);
      if(useShopifyCart){
        if(!item.variantId){
          const original=add.textContent;
          add.textContent='Choose a product';
          window.setTimeout(()=>add.textContent=original,1800);
          return;
        }
        const original=add.textContent;add.disabled=true;add.textContent='Adding…';
        const ok=await addShopifyItem(item);
        add.disabled=false;add.textContent=original;
        if(!ok){add.textContent='Please try again';window.setTimeout(()=>add.textContent=original,1800);return}
        if(add.hasAttribute('data-buy-now')){window.location.href=shopifyRoutes.cartUrl||shopifyRoutes.checkoutUrl;return}
        window.setTimeout(openCart,120);
      }else{addItem(item);window.setTimeout(openCart,240)}
    }
  });
  searchInput.addEventListener('input',()=>renderSearch(searchInput.value));
  searchPanel.addEventListener('click',event=>{if(event.target===searchPanel) closeSearch()});
  document.addEventListener('keydown',event=>{if(event.key==='Escape'){closeCart();closeSearch()}});
})();
